import { ProjectFilenameTemplateItem } from '../classes/ProjectFilenameTemplateItem'

export const ProjectName = new ProjectFilenameTemplateItem({
  id: '5F93D0A6-6F98-4BA7-88C3-BEA286337F41',
  name: 'Project Name',
  property: 'projectName',
  help: 'Project Name from Projects table',
})

export const ClientProjectNumber = new ProjectFilenameTemplateItem({
  id: '3FE3EA43-A849-4C61-A695-AE2683EE9392',
  name: 'Project Number/Pin',
  property: 'clientProjectNumber',
  help: 'Client Project Number from Projects table',
})

export const ClientProjectName = new ProjectFilenameTemplateItem({
  id: 'DCABCA28-3CCF-4679-9806-CE8A1877E6FF',
  name: 'Client Project Name',
  property: 'clientProjectName',
  help: 'Client Project Name from Projects table',
})

export type ProjectFilename =
  | typeof ProjectName
  | typeof ClientProjectNumber
  | typeof ClientProjectName
